module.exports = [{
      plugin: require('/home/jacksonblack/rebassjs.org/www/node_modules/gatsby-mdx/gatsby-browser.js'),
      options: {"plugins":[],"extensions":[".mdx",".md"]},
    },{
      plugin: require('/home/jacksonblack/rebassjs.org/theme/gatsby-browser.js'),
      options: {"plugins":[],"navigation":[{"text":"Rebass","href":"/"},{"text":"Getting Started","href":"/getting-started"},{"text":"Props","href":"/props"},{"text":"Extending","href":"/extending"},{"text":"Theming","href":"/theming"},{"text":"Box","href":"/Box"},{"text":"Flex","href":"/Flex"},{"text":"Text","href":"/Text"},{"text":"Heading","href":"/Heading"},{"text":"Button","href":"/Button"},{"text":"Link","href":"/Link"},{"text":"Image","href":"/Image"},{"text":"Card","href":"/Card"},{"text":"Advanced","href":"/advanced"},{"text":"Recipes","href":"/recipes"}]},
    },{
      plugin: require('/home/jacksonblack/rebassjs.org/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-4603832-13"},
    },{
      plugin: require('/home/jacksonblack/rebassjs.org/www/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
